import api from './client'
import type { ResetTarget, VocabularyEntry, VocabularyStats } from '@/types/vocabulary'

export function fetchVocabulary(languageId: number) {
  return api.get<{ data: VocabularyEntry[] }>('/vocabulary', {
    params: { language_id: languageId },
  })
}

/** Deletes the signed-in user's own vocabulary for one language. Irreversible. */
export function resetVocabulary(
  languageId: number,
  targets: ResetTarget[],
  deckIds: number[],
) {
  return api.post<{ data: { deleted: Record<string, number> } }>('/vocabulary_reset', {
    language_id: languageId,
    targets,
    deck_ids: deckIds,
  })
}

export function fetchVocabularyStats(languageId: number) {
  return api.get<{ data: VocabularyStats }>(`/languages/${languageId}/vocabulary_stats`)
}
